(function () {
    'use strict';

    angular
        .module('sodNotificationCenter')
        .factory('NotificationCenterService', NotificationCenterService);

    function NotificationCenterService(lodash, $interval) {
        const mem = {};
        // init();
        return {
            getTotal: getTotal,
            getData: getData,
            getUpdatedTime: getUpdatedTime,
            destroy: destroy
        };

        function init() {
            run();
            mem.intervalRef = $interval(run, 1000);
        }

        function run() {
            lodash.set(mem, 'data', {
                rows: [
                    { name: 'Test: ' + (new Date()).getTime() }
                ],
                count: Math.round(Math.random() * 10)
            });
            lodash.set(mem, 'updated', (new Date()).getTime());
        }

        function getTotal() {
            return lodash.get(mem, 'data.count', 0);
        }

        function getData() {
            return lodash.get(mem, 'data.rows', []);
        }

        function getUpdatedTime() {
            return lodash.get(mem, 'updated', null);
        }

        function destroy() {
            if (lodash.has(mem, 'intervalRef')) {
                mem.intervalRef();
            }
        }
    }
})();